import './layout.scss';

import { Outlet } from 'react-router';

import { BottomTabBar, Header } from './widgets';

/**
 * Каркас экранов с нижней навигацией: прокручиваемый контент + персистентный таб-бар.
 * Таб-бар не размонтируется при смене маршрута (и не дёргает iframe сервиса под собой).
 */
const Layout: React.FC = () => {
  return (
    <div className="layout">
      <Header />
      <div className="layout__content">
        <Outlet />
      </div>
      <BottomTabBar />
    </div>
  );
};

export default Layout;
